import {SpecimenGuideData} from './types'

export const specimenGuideData: () => SpecimenGuideData = () =>
  require('../../public/specimen-guide/data.json')
